import React from 'react'
import { useEffect, useState, useRef } from "react";
import axios from "axios";

import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
} from "@chakra-ui/modal";
import { useDisclosure } from '@chakra-ui/react';
import { Box, Stack, Text } from "@chakra-ui/layout";
import { Input, Button ,Divider, IconButton,Tabs, TabList, TabPanels, Tab, TabPanel, Tooltip } from '@chakra-ui/react'
import { AddIcon,SearchIcon, ArrowBackIcon } from "@chakra-ui/icons";


import { Spinner } from "@chakra-ui/spinner";
import { useToast } from "@chakra-ui/toast";
import ChatLoading from "./ChatLoading";
import  EnvRoute   from '../middleware/envRoute';

import { ChatState } from "../context/chatProvider"

import UserListItem from "./userAvatar/UserListItem";

const ENDPOINT = EnvRoute('prod'); 



const SearchDrawer = () => {
   let { isOpen, onOpen ,onClose } = useDisclosure();
 const [ search, setSearch ] = useState("")
 const [ searchResult, setSearchResult ] = useState([])
 const [ loading, setLoading ] = useState(false)
 const [ loadingChat, setLoadingChat ] = useState()
  const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();

   const toast = useToast();


const checkForSearch = () => {
 if (!search) {
      toast({
        title: "Please Enter something in search",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top-left",
      });
      return;
    }else{handleSearch(search)}

}
const handleSearch = async (query) =>{
   setSearch(query)
    try {
        setLoading(true);

        const config = {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
      };

      const  data  = await axios.get(`${ENDPOINT}/api/user?search=${search}`, config);

      setLoading(false);
      setSearchResult([...data.data]);

    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Search Results",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
 }
 const accessChat = async (userId) => {
    console.log(userId);

    try {
      setLoadingChat(true);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.post(`${ENDPOINT}/api/chat`, { userId }, config);

      if (!chats.find((c) => c._id === data._id)) setChats([data, ...chats]);

      setSelectedChat(data);
      setLoadingChat(false);
      onClose();
    } catch (error) {
      toast({
        title: "Error fetching the chat",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };



  return (
<>
     <Tooltip 
            label="Search users to chat" 
            hasArrow 
            placement='bottom-end'>
              <Button 
            m={'5px 5px'}

                h={'25px'}
                w={'fit-content'}
                onClick={onOpen}
                 color={'txt.hdrDrk'}
              variant={'ghost'}
              padding={'0.5rem'}
            // colorScheme='blue'
            border={'1px solid #868686'}
            borderBottom={'none'}
            borderRadius={'5px 0px 5px 0px'}
            // minW={{ base: "12px", sm: "11px", md: "11px", lg: "12px" }}
            
            fontSize={{ base: "16px", sm: "16px", md: "16px", lg: "16px" }}
              border={'1px solid #868686'}

                borderRadius={'5px 5px 0px 0px'}
                leftIcon={<SearchIcon alignSelf={'center'} fontSize={'0.75rem'}/>}
                // borderBottom={'none'}
                color='#868686'>
                {/* <i className="fas fa-search"> </i> */}
                <Text
                  display={{base:"none", sm: "flex", md: "flex", lg: "flex"}} 
                  px={0}
                  py={1}
                >Users</Text>
              </Button>
          </Tooltip>
   <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />

        <DrawerContent

        //  backgroundImage={"url('./assets/BodyBG.png')"}
        backgroundSize={"cover"}
        borderRadius={"0px 10px 0 0"}
        boxShadow={'bxshd.inset_lt_bl'}
        backgroundColor={"bgs.bgsMain"}
        >
          <DrawerHeader
           bg={'white'}
            borderRadius={"10px 10px 0 0"}
          

            // background={"url('./assets/BodyBG.png')"}
            // backgroundSize={'cover'}
            boxShadow={'bxshd.inset_lt_bl'}
           borderBottomWidth="1px">
             <Box display={'flex'} w={'100%'} flexDirection={'row'} justifyContent={'space-evenly'}>

        <IconButton
              // display={{ base: "flex" }}
              // boxShadow={'bxshd.inset_lt_bl'}
              position={'absolute'}
              left={1}
              
              h={'30px'}
              w={'30px'}
              // m={1}
              background={"#FFFFFF91"}
               backdropFilter={"blur(4px)"}
                 border = {`1px solid #868686`}
                // _placeholder={{ opacity: 0.9, color: '#868686' }}
              color={"#868686"}
              borderRadius = "0px 10px  0px 10px"
              borderBottom={'none'}
              borderRight={'none'}
              icon={<ArrowBackIcon />}
              onClick={()=>{onClose()}}
            />
             Search Users
        </Box>
             </DrawerHeader>
          <DrawerBody>
            <Box display="flex" pb={2}>
              <Input
                placeholder="Search by name or email"
                mr={2}
                value={search}
                // onChange={(e) => setSearch(e.target.value)} 
                onChange={(e) => handleSearch(e.target.value)}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                
             />
              <Button 
              borderRadius = "10px 10px 10px 10px"
               background={"rgba(255, 255, 255, 0.3)"}
               backdropFilter={"blur(4px)"}
                 border = {`2px solid #868686`}
                boxShadow={'bxshd.inset_blk'}
                // borderBottom={'None'}
              onClick={checkForSearch}>Go</Button>
            </Box>
            {loading ? (
              <ChatLoading />
            ) : (
              searchResult?.map((user) => (
                // user
                <UserListItem
                  key={user._id}
                  user={user}
                  handleFunction={() => accessChat(user._id)}
                  
                />
              ))
            )}
            {loadingChat && <Spinner ml="auto" display="flex" />}
          </DrawerBody>
        </DrawerContent>
        </Drawer>
</>
  )
}

export default SearchDrawer